import { defineComponent, unref, resolveComponent, isRef, ref } from 'vue';import { useStore } from 'vuex';import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fa843ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "display-box"
};
const _hoisted_2 = {
  class: "cont"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'confirmErrMsg',
  setup(__props) {
    const {
      state,
      commit
    } = useStore();
    const confirmErrMsg = state.moduleCommon.confirmErrMsgObj;
    const visible = ref(true);
    const text = confirmErrMsg.content;
    const closeEvent = () => {
      commit('moduleCommon/CONFIEM_ERR_MSG_OBJ', {
        show: false,
        content: ''
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_selfDialog = _resolveComponent("selfDialog");
      return _openBlock(), _createBlock(_component_selfDialog, {
        visible: _unref(visible),
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        onOnCloseDialog: closeEvent,
        width: 460,
        alignCenter: true
      }, {
        header: _withCtx(() => [_createTextVNode(" 错误提示 ")]),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_unref(text)), 1)])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "danger",
          onClick: closeEvent
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});